import React, { useState } from 'react'
import styled from 'styled-components'

import SvgIconCaretDown from 'components/icons/CaretDown'

const DropdownButton = styled.button`
  background-color: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
  width: 100%;
  font-weight: 400;

  &:not(.close-nav) {
    svg {
      transform: rotate(180deg);
    }
  }

  &.close-nav {
    & + ul {
      max-height: 0;
    }
  }

  svg {
    width: 10px;
    height: 5px;
    margin-left: 15px;
  }
`

const DropdownList = styled.ul`
  transition: max-height 0.4s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  padding: 0;
  max-height: 200px;
  overflow: hidden;

  li {
    padding-left: 8px;
    margin-top: 8px;
  }
`

interface MenuDropdownProps {
  name: string
  url: string
  dropDownItems: {
    name: string
    url: string
    annotation?: React.ReactNode
  }[]
}

const DropdownMenu = ({ name, url, dropDownItems }: MenuDropdownProps) => {
  const [openDropdown, setOpenDropdown] = useState(false)

  return (
    <>
      <DropdownButton
        type="button"
        onClick={() => setOpenDropdown(!openDropdown)}
        className={!openDropdown && 'close-nav'}
      >
        {dropDownItems.length > 0 ? (
          <>
            {name}
            <SvgIconCaretDown />
          </>
        ) : (
          <a href={url}>{name}</a>
        )}
      </DropdownButton>

      {dropDownItems.length > 0 && (
        <DropdownList>
          {dropDownItems.map((item) => (
            <li key={item.name}>
              <a href={item.url}>
                {item.name}
                {item.annotation}
              </a>
            </li>
          ))}
        </DropdownList>
      )}
    </>
  )
}

export default DropdownMenu
